import { useSearchParams } from 'react-router-dom';
import { useEnquiryForm, Honeypot, Field } from '../components/Form.jsx';
import { CONTACT } from '../content/site.js';

const KINDS = {
  contact: { label: 'General enquiry', heading: 'Get in touch' },
  consultation: { label: 'Book a consultation', heading: 'Book a consultation' },
  seminar: { label: 'Community seminar', heading: 'Book a free seminar' },
};

export default function Contact() {
  const [params, setParams] = useSearchParams();
  const kind = KINDS[params.get('kind')] ? params.get('kind') : 'contact';
  const subject = params.get('subject') || '';
  const { submit, state, error, sending, done } = useEnquiryForm(kind);

  return (
    <>
      <section className="page-head">
        <div className="shell">
          <p className="eyebrow">Contact</p>
          <h1>{KINDS[kind].heading}</h1>
          <p className="lede" style={{ marginTop: '1.2rem' }}>
            A person reads every message. Tell us what you are trying to solve and we will point
            you in the right direction — even if that turns out not to be us.
          </p>
        </div>
      </section>

      <section className="section" style={{ paddingTop: '2.5rem' }}>
        <div className="shell contact-grid">
          <div>
            <div className="filters" style={{ marginBottom: '2rem' }}>
              {Object.entries(KINDS).map(([key, v]) => (
                <button
                  key={key}
                  type="button"
                  className={`filter${kind === key ? ' on' : ''}`}
                  onClick={() => setParams(key === 'contact' ? {} : { kind: key })}
                >
                  {v.label}
                </button>
              ))}
            </div>

            {done ? (
              <div className="railed" role="status">
                <h2>Message sent.</h2>
                <p className="dim" style={{ marginTop: '0.8rem' }}>
                  You'll get an acknowledgement by email, and a reply from a person within one
                  business day. If it's an active incident, call {CONTACT.phone}.
                </p>
              </div>
            ) : (
              <form onSubmit={submit} noValidate={false}>
                <Honeypot />
                <div className="grid grid-2">
                  <Field label="Name" name="name" autoComplete="name" required />
                  <Field label="Email" name="email" type="email" autoComplete="email" required />
                </div>
                <div className="grid grid-2">
                  <Field label="Company" name="company" autoComplete="organization" />
                  <Field label="Phone" name="phone" type="tel" autoComplete="tel" />
                </div>
                <Field label="Subject" name="subject" defaultValue={subject} />
                <Field
                  label="How can we help?"
                  name="message"
                  textarea
                  required
                  placeholder={
                    kind === 'seminar'
                      ? 'Roughly how many people, what kind of group, and where are you?'
                      : 'What are you trying to solve?'
                  }
                />

                {error && <p className="check-error" role="alert">{error}</p>}

                <button type="submit" className="btn btn-primary" disabled={sending}>
                  {sending ? 'Sending…' : 'Send message'}
                </button>
                <p className="faint" style={{ marginTop: '1rem', fontSize: '0.82rem' }}>
                  We use what you send here to reply to you, and nothing else. No list, no
                  reselling. See our <a href="/privacy">privacy policy</a>.
                </p>
              </form>
            )}
          </div>

          <aside className="contact-aside">
            <h3>Direct</h3>
            <ul className="footer-list">
              <li><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
              <li><a href={`tel:${CONTACT.phoneHref}`}>{CONTACT.phone}</a></li>
            </ul>

            <h3 style={{ marginTop: '2rem' }}>Security reports</h3>
            <ul className="footer-list">
              <li><a href={`mailto:${CONTACT.security}`}>{CONTACT.security}</a></li>
            </ul>

            <h3 style={{ marginTop: '2rem' }}>Office</h3>
            <p className="dim" style={{ fontSize: '0.9rem', lineHeight: 1.6 }}>
              {CONTACT.address.map((l) => <span key={l}>{l}<br /></span>)}
            </p>
          </aside>
        </div>
      </section>
    </>
  );
}
